import { createSelector } from 'reselect';

const selectDomain = (state) => state.passwordReset;

export const selectSending = createSelector([selectDomain], (state) => state.get('sending'));
export const selectMessage = createSelector([selectDomain], (state) => state.get('message'));
export const selectError = createSelector([selectDomain], (state) => state.get('error'));
